module.exports = __webpack_public_path__ + "img/directory_meta_banner.38dc025.png";